export default "__VITE_ASSET__DGPVEPSg__"